import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/main.scss';
const Home = lazy(() => import('./components/home'));
const MenuList = lazy(() => import('./components/booking/MenuList'));
const BusPnrEnquiry = lazy(() => import('./components/booking/BusPnrEnquiry'));
const ObReferenceNumber = lazy(()=> import('./components/booking/ObReferenceNumber'));
const MobileBasedEnquiry = lazy(() => import('./components/booking/MobileBasedEnquiry'));
const EmailBasedEnquiry = lazy(()=>import('./components/booking/EmailBasedEnquiry'));
const MobileEmailBasedEnquiry = lazy(() => import('./components/booking/MobileEmailBasedEnquiry'));

const Booking = lazy(() => import('./components/booking'));
const BookingStatus = lazy(() => import('./components/booking/bookingStatus'));
const PaymentStatus = lazy(() => import('./components/payment/paymentStatus'));
const PnrDetails = lazy(() => import('./components/booking/pnrDetails'));
const Payment = lazy(() => import('./components/payment'));
const Trip = lazy(() => import('./components/trip'));
const TripStatus = lazy(() => import('./components/trip/tripStatus'));

function App() {
  return (
    <Router >
      <ErrorBoundary>
        <Suspense fallback={<div>loading...</div>}>
          <Routes>
            <Route exact path="/status" element={<MenuList />} />
            <Route path="/status/bus_pnr_enquiry" element={<BusPnrEnquiry />} />
            <Route path="/status/ob_reference_number" element={<ObReferenceNumber />} />
            <Route path="/status/mobile_based_enquiry" element={<MobileBasedEnquiry />} />
            <Route path="/status/email_based_enquiry" element={<EmailBasedEnquiry />} />
            <Route path="/status/mobile_email_based_enquiry" element={<MobileEmailBasedEnquiry />} />
            
            <Route path="/status/booking" element={<Booking />} />
            <Route path="/status/booking/:id" element={<BookingStatus />} />
            <Route path="/status/pnrDetails/:id" element={<PnrDetails />} />
            <Route path="/status/payment" element={<Payment />} />
            <Route path="/status/payment/:id" element={<PaymentStatus />} />
            <Route path="/status/trip" element={<Trip />} />
            <Route path="/status/trip/:id" element={<TripStatus />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

const ErrorPage = () => (
  <div className='err-screen'>
    Oops! some error occured!
    <br />
    <br />
    <a href='/' target='_self'>GO TO HOME</a>
  </div>
)

export default App;
